<template>
  <div class="container px-2 md:px-0 mx-auto space-y-2">
    <!-- Membership Section -->
    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Pakket</h3>
        <p class="mt-1 text-sm text-gray-600">
          Beheer je abbonement en facturatie.
        </p>
      </div>
      <div class="md:w-2/3 p-6 bg-white shadow-md rounded-lg">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-blue-600 uppercase">Huidig pakket</p>
            <h4 class="text-2xl font-bold text-gray-900 mt-1">{{ currentPlanName }}</h4>
            <p class="text-sm text-gray-600 mt-1">{{ currentPlanDescription }}</p>
          </div>
          <router-link
            :to="{ name: 'Settings/subscription' }"
            class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-semibold text-sm transition"
          >
            Pakket wijzigen
          </router-link>
        </div>
      </div>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Profile</h3>
        <p class="mt-1 text-sm text-gray-600">
          Update your account's profile information and email address.
        </p>
      </div>
      <profile-update class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></profile-update>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Password</h3>
        <p class="mt-1 text-sm text-gray-600">
          Ensure your account is using a long, random password to stay secure.
        </p>
      </div>
      <password-update class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></password-update>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Two Factor Authentication</h3>
        <p class="mt-1 text-sm text-gray-600">
          Add additional security to your account using two factor authentication.
        </p>
      </div>
      <two-factore-authentication class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></two-factore-authentication>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import TwoFactoreAuthentication from '@/components/user/TwoFactoreAuthentication.vue'
import ProfileUpdate from '@/components/user/ProfileUpdate.vue'
import PasswordUpdate from '@/components/user/PasswordUpdate.vue'

export default {
  components: {
    TwoFactoreAuthentication,
    ProfileUpdate,
    PasswordUpdate,
  },
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return this.authStore?.currentUser
    },
    currentPlan() {
      // Get plan from user, default to 'start' if not set
      return this.currentUser?.plan || this.currentUser?.subscription_tier || 'start'
    },
    currentPlanName() {
      const plans = {
        'start': 'Start',
        'pro': 'Pro',
        'business': 'Business'
      }
      return plans[this.currentPlan.toLowerCase()] || 'Start'
    },
    currentPlanDescription() {
      const descriptions = {
        'start': 'Perfect om te beginnen',
        'pro': '€19 per maand',
        'business': '€49 per maand'
      }
      return descriptions[this.currentPlan.toLowerCase()] || 'Perfect om te beginnen'
    }
  }
}
</script>
